import React, {PureComponent} from 'react';
import styles from './date.module.scss';
import moment from 'moment'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

class DateField extends PureComponent {
    constructor(props) {
        super(props)
        const [from, to] = this.initDate(props.value || '')
        this.state = {
            ...props,
            from: from,
            to: to,
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
            const [from, to] = this.initDate(this.props.value)
            this.setState({
                from: from,
                to: to,
            })
        }
    }

    initDate(value) {
        if (!value || typeof value !== 'string') return [null, null];
        const [rawFrom, rawTo] = value.replace("[", '').replace("]", '').split('-');
        const mFrom = moment(String(rawFrom || '').trim(), 'MM/DD/YYYY', true);
        const mTo = moment(String(rawTo || '').trim(), 'MM/DD/YYYY', true);
        return [mFrom.isValid() ? mFrom.toDate() : null, mTo.isValid() ? mTo.toDate() : null];
    }

    changeFrom = (from)=> {
        this.setState({ from })
        this.handleInputs(from, this.state.to)
    }

    changeTo = (to) => {
        this.setState({to})
        this.handleInputs(this.state.from, to)
    }

    changeFromRaw = (e) => {
        const raw = e.target.value;
        if (!raw) {
            this.setState({ from: null });
            return;
        }
        const m = moment(String(raw).trim(), 'MM/DD/YYYY', true);
        if (m.isValid()) {
            const d = m.toDate();
            this.setState({ from: d });
            this.handleInputs(d, this.state.to);
        }
    }

    changeToRaw = (e) => {
        const raw = e.target.value;
        if (!raw) {
            this.setState({ to: null });
            return;
        }
        const m = moment(String(raw).trim(), 'MM/DD/YYYY', true);
        if (m.isValid()) {
            const d = m.toDate();
            this.setState({ to: d });
            this.handleInputs(this.state.from, d);
        }
    }

    handleInputs(from, to) {
        if (from !== null && to !== null) {
            const format = 'MM/DD/YYYY'
            const from_r = moment(from).format(format)
            const to_r = moment(to).format(format)
            let value = `[${from_r}-${to_r}]`
            const label = `${from_r} - ${to_r}`
            let e = {target: { value, name: this.props.inputId}}
            this.props.handleInputs(e, label)
        }
    }

    render() {
        const {inputId} = this.props;
        const {from, to} = this.state
        return (
            <div className={styles.root}>
                <DatePicker
                    className={styles.field}
                    selected={from}
                    onChange={this.changeFrom}
                    onChangeRaw={this.changeFromRaw}
                    name={inputId + '-from'}
                />
                <DatePicker
                    className={styles.field}
                    selected={to}
                    onChange={this.changeTo}
                    onChangeRaw={this.changeToRaw}
                    popperPlacement={'bottom-end'}
                    name={inputId + '-to'}
                />
            </div>
        );
    }
}

export default DateField;